import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface AlertMessageProps {
  type: 'error' | 'success';
  message: string;
}

export const AlertMessage: React.FC<AlertMessageProps> = ({ type, message }) => {
  if (type === 'error') {
    return (
      <Alert variant="destructive" className="mb-4">
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert className="mb-4 border-primary/30 bg-primary/10">
      <AlertDescription className="text-foreground">{message}</AlertDescription>
    </Alert>
  );
};

